import { FC } from "react";

export type StepperHeaderProps = {
    totalStep: number;
    currentStep: number;
    handleBack: () => void;
    handleNext: () => void;
    onClose: () => void;
    hasBackButton: boolean
    isFromNeedToVerifyProfile?: boolean;
}

const StepperHeader: FC<StepperHeaderProps> = ({ onClose, totalStep, currentStep, handleBack, handleNext, hasBackButton, isFromNeedToVerifyProfile }) => {

    return (
        <>
            <div className="top_sec signup wf-section">
                <div className="signup_status_group">
                    <div className="status_num">
                        <div>{totalStep}</div>
                        <div>/</div>
                        <div>
                            <strong>{currentStep}</strong>
                        </div>
                    </div>
                    {!isFromNeedToVerifyProfile && <a className="top_back close w-inline-block" onClick={onClose}>
                        <img src="assets/images/ic_top_close.svg" loading="lazy" alt="" />
                    </a>}
                    {hasBackButton && currentStep !== 1
                        ?
                        <a href="#" onClick={handleBack} className="top_back signup w-inline-block">
                            <img src="assets/images/ic_back_white.svg" loading="lazy" alt="" />
                        </a>

                        :
                        null
                    }

                </div>
                <div className="progress_bar">
                    <div className="progress_line" style={{
                        width: `${100 / totalStep * currentStep}%`
                    }} />
                </div>
            </div>
        </>
    )
}

export default StepperHeader;